export default {
  install(Vue) {
    Vue.prototype.$pageVisibility = Vue.observable({
      hidden: document.hidden,
      state: document.visibilityState
    });

    document.addEventListener("visibilitychange", () => {
      Vue.prototype.$pageVisibility.hidden = document.hidden;
      Vue.prototype.$pageVisibility.state = document.visibilityState;
    });
  }
};
